<template>
  <PartnersList
    :config="config"
    :custom-query="{
      role: 3,
      includepartners: false,
    }"
  />
</template>

<script>
import PartnersList from './PartnersList.vue'

import storeModule from '../companyStoreModule'

export default {
  components: {
    PartnersList,
  },
  computed: {
    config() {
      return {
        store: storeModule,
        module: 'companies',
        endpoint: 'companies',
        route: 'companies',
        filtersOpen: true,
        title: {
          single: this.$i18n.t('Seller'),
          plural: this.$i18n.t('Sellers'),
        },
      }
    },
  },
}
</script>
